<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    style="background-color: white;"
  >
    <CSidebarBrand class="d-md-down-none mt-3 text-left" to="/" style="background-color: white;">
      <div class="text-left">
      <img src="../assets/image/logo.png" :height="30" alt="Dashboard of Interviewrr.ai"/> <label class="custom-20px-700 ml-2"></label>
    </div>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav" class="font-color-171717"/>
    <!-- <CRenderFunction flat :content-to-render="selectedNavigationMenu" /> -->
    <!-- <CSidebarMinimizer
      class="d-md-down-none font-color-171717"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    >Logout</CSidebarMinimizer> -->
    <div class="mt-auto"> <!-- Use mt-auto to push the content to the bottom -->
      <CButton class="mb-2" v-on:click="GoSetting()"><img style="max-width:20px" src="../assets/image/iconSetting.png" alt="Interviewrr.ai icon logout" class="mr-2"/>Setting</CButton>
      <br />
      <CButton class="mb-2" v-on:click="HelpCenter()"><img style="max-width:20px" src="../assets/image/iconHelpCenter.png" alt="Interviewrr.ai icon logout" class="mr-2"/>Help Center</CButton>
      <br />
      <CButton class="mb-2 text-danger" v-on:click="SignOut()"><img style="max-width:20px" src="../assets/image/iconLogout.png" alt="Interviewrr.ai icon logout" class="mr-2"/>Logout</CButton>
    </div>
  </CSidebar>
</template>

<script>
import nav from './_navcompany'
import navOur from './_navOur'

export default {
  name: 'TheSidebar',
  nav,
  navOur,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },
  data() {
    return {
      user: null,
      email: '',
      selectedNavigationMenu: [],
    };
  },
  async mounted() {
        //this.GetInfoUser();
    },
  methods:
  {
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });
    },
    HelpCenter()
    {
      this.$router.push("HelpCenter");
    },
    GoSetting()
    {
      this.$router.push("Setting");
    }
    // async GetInfoUser() {
    //         try {
    //             const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
    //             if (response.status === 200 && response.data) {
    //                 this.user = response.data;
    //                 this.email = this.user.email;
    //                 this.getNavigationMenu(this.email);
    //             } else {
    //                 console.error("User info retrieval failed:", response.data.detail);
    //             }
    //         } catch (error) {
    //             console.error("Error fetching user info:", error);
    //         }
    //     },
    //     getNavigationMenu(email) {
    //   if (email === "contact@interviewrr.ai") {
    //     this.selectedNavigationMenu = navOur;
    //   } else {
    //     this.selectedNavigationMenu = nav;
    //   }
    // }
  }
}
</script>
